<template>
  <div class="container" ref="container">
    <div class="left-right-container">
      <LeftPanel 
        v-show="!isMobile || (isMobile && showLeftPanel)"
         class="left-panel"
        :class="{ 'full-width': isMobile && showLeftPanel }"
        :style="{ flex: leftFlex }"
        @changePanel="togglePanel"
        @closeLeftPanel="closeLeftPanel"
      ></LeftPanel>
      <div v-show="!isMobile" class="divider" @mousedown="startDraggingLeft"></div>
      
        <CenterPanel
        v-show="!isMobile || (isMobile && !showLeftPanel && !isPanelVisible)"
          class="center-panel" 
          :class="{ 'full-width': isMobile }"
          :style="{ flex: centerFlex }"
        ></CenterPanel>

        <div v-show="!isMobile && !isUser" class="divider"  @mousedown="startDraggingRight"></div>
        <FrontDeskRightPanel v-if="!isMobile && !isUser  && showrightPanel " class="right-panel" :style="{ flex: right_Flex }"
        ></FrontDeskRightPanel>
        <!-- for Mobile view -->
        <RightPanel v-show="isMobile && !showLeftPanel && isPanelVisible" class="right-panel" :style="{ flex: right_Flex }"></RightPanel>
    </div>
  </div>
</template>

<script>
import LeftPanel from "@/components/FrontDesk/LeftPanel";
import CenterPanel from "@/components/FrontDesk/CenterPanel";
import RightPanel from "../components/FrontDesk/RightPanel/RightPanel.vue";
import EventBus from "@/eventBus";
import FrontDeskRightPanel from "./FrontDeskRightPanel"
import router from "@/router";
import { setCustomBackHandler, clearCustomBackHandler ,useDefaultBackHandler} from '@/backButtonManager'

import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "FrontDesk",
  data() {
    return {
      isDraggingLeft: false,
      isDraggingRight: false,
      leftFlex: 3.5,
      centerFlex: 9,
      rightFlex : 7,
      startX: 0,
      showLeftPanel: true,
      showrightPanel: true,
    };
  },
  components: {
    LeftPanel,
    CenterPanel,
    RightPanel,
    FrontDeskRightPanel,
  },
  watch:{
    showLeftPanel(newVal) {
      if (!newVal) {
        this.showBottomNav(false);// hide bottom nav when center panel is opened
      }else{
        this.showBottomNav(true);// show bottom nav when left panel is opened
      }
    },
  },
  computed: {
    ...mapState(["isPanelVisible"]),
    ...mapGetters("frontdesk",["isUser"]),
    ...mapGetters("window", ["isMobile"]),    
    ...mapGetters("osclaims", ["claim"]),
    right_Flex() {
      return this.isPanelVisible ? this.rightFlex : 0.5;
    },
  },
  methods: {
    ...mapMutations("window", ["showBottomNav"]),
    ...mapMutations(["changeRightPanelStatus"]),
    adjustCenterFlex() {
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;
      this.centerFlex = totalFlex - this.leftFlex - this.rightFlex;
    },
    ...mapActions("frontdesk", ["retrieveCalls","getMessageTemplates"]),
    ...mapActions("people", ["getUsers"]),
    async initialize() {
      try {
        await this.getUsers();
        await this.getMessageTemplates();
      } catch (err) {
        console.log("Error in FrontDesk vue in initialize", err);
      }
    },
    startDraggingLeft(event) {
      this.isDraggingLeft = true;
      this.startX = event.clientX;
      document.addEventListener("mousemove", this.onDragLeft);
      document.addEventListener("mouseup", this.stopDragging);
    },
    onDragLeft(event) {
      if (!this.isDraggingLeft) return;
      const deltaX = event.clientX - this.startX;
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;

      const containerWidth = this.$refs.container.offsetWidth;
      const deltaFlex = (deltaX / containerWidth) * totalFlex;

      this.leftFlex = Math.max(1, Math.min(totalFlex - 2, this.leftFlex + deltaFlex));
      this.adjustCenterFlex();

      this.startX = event.clientX;
    },
    startDraggingRight(event) {
      this.isDraggingRight = true;
      this.startX = event.clientX;
      document.addEventListener("mousemove", this.onDragRight);
      document.addEventListener("mouseup", this.stopDragging);
    },
    onDragRight(event) {
      if (!this.isDraggingRight) return;
      const deltaX = this.startX - event.clientX; 
      const totalFlex = this.leftFlex + this.centerFlex + this.rightFlex;

      const containerWidth = this.$refs.container.offsetWidth;
      const deltaFlex = (deltaX / containerWidth) * totalFlex;

      this.rightFlex = Math.max(1, Math.min(totalFlex - 2, this.rightFlex + deltaFlex));
      this.adjustCenterFlex();

      this.startX = event.clientX;
    },
    stopDragging() {
      this.isDraggingLeft = false;
      this.isDraggingRight = false;
      document.removeEventListener("mousemove", this.onDragLeft);
      document.removeEventListener("mousemove", this.onDragRight);
      document.removeEventListener("mouseup", this.stopDragging);
    },
    // for Mobile options
    togglePanel() {
      if (this.isMobile) {
        this.showLeftPanel = !this.showLeftPanel; // Toggle between Left and Center Panel
      }
    },
    closeLeftPanel() {
      if (this.isMobile) {
        this.showLeftPanel = false; // Close Left Panel
      }
    },
    goLeftPanel(){
      if(!this.showLeftPanel){
        this.showLeftPanel = true;
      }
    },
    closeRightPanel(){
      this.changeRightPanelStatus(false);
    }
  },
  async created() {
    await this.initialize();
    //  await this.retrieveCalls();
  },
  mounted() {
console.log("Capacitor platrofrm "+Capacitor.getPlatform());
     if (Capacitor.getPlatform() === 'android') {
   	setCustomBackHandler(() => {
	console.log("custom back handler called showLeft Panle"+this.showLeftPanel+" and ispanelvis"+this.isPanelVisible);
	if(!this.showLeftPanel && this.isPanelVisible){
		this.closeRightPanel();
	}else if(!this.showLeftPanel && !this.isPanelVisible){
			 this.goLeftPanel();
	}else{
		useDefaultBackHandler(router);
	}
     });
   }
    EventBus.$on("back-to-FDLeft", () => {
      this.togglePanel();
    });
    EventBus.$on("showRightPanel", (visible) => {
      console.log("Panel state:", visible);
      this.showrightPanel = visible;
     })
  },
  beforeUnmount(){
    this.$store.commit('setContact',{});
    EventBus.$off("showRightPanel");
    this.$store.commit('changeRightPanelStatus',false);
    clearCustomBackHandler();	
  }
};
</script>

<style scoped>
.container {
  display: flex;
  height: 100%;
 
}
.left-right-container {
  display: flex;
  height: 100%;
  width: 100%;
}
.left-panel {
  flex: 3.5;
  min-width: 280px;
}
.center-panel {
  flex: 12;
}
.right-panel {
  flex: 6;
}
.divider {
  width: 2px;
  background-color: #000;
  cursor: ew-resize;
}
.divider:hover{
  background-color: blue;
  width: 5px;
}
.full-width {
  width: 20%;
  flex: 1;
}
</style>

<style scoped>
.hidden {
  display: none;
}
</style>